import { ACCENT_COLORS } from './constants'

/**
 * A client's accent colour, derived from its id. Not stored: the Portal API
 * has no accent field (APP-53), and the colour's job is only to tell tenants
 * apart on screen (docs/02-app-shell.md §1).
 *
 * Numeric ids — the API's — take the id modulo the palette, so up to eight
 * consecutive ids never share a colour. Other ids (the mock's) are hashed.
 */
export function accentFor(clientId: string): string {
  const n = /^\d+$/.test(clientId)
    ? Number(clientId)
    : [...clientId].reduce((h, ch) => (h * 31 + ch.charCodeAt(0)) >>> 0, 0)
  return ACCENT_COLORS[n % ACCENT_COLORS.length]!
}
